import { useNavigate } from "react-router-dom";
import { TableCell, TableRow, Box } from "@mui/material";
import { getVersionNumber } from "../../utils/formatVersionLabel";
import { formatDate } from "../../utils/formatDate";

const TestRunsListItem = ({ testRun, testCase, onSelectRun = null }) => {
    const navigate = useNavigate();
    const publicId = testCase?.public_id || testCase?.publicId || null;

    const statusStyles = {
        PENDING: { backgroundColor: "#F0AD4E", color: "#fff" },
        RUNNING: { backgroundColor: "#4574D2", color: "#fff" },
        COMPLETED: { backgroundColor: "#198754", color: "#fff" },
        FAILED: { backgroundColor: "#D32F2F", color: "#fff" },
        INITIAL_FAILURE: { backgroundColor: "#8E1515", color: "#fff" }, 
        CANCELLED: { backgroundColor: "#F8DF73", color: "#2D4356" },
    };

    const handleShowTestRun = () => {
        if (typeof onSelectRun === "function") {
            onSelectRun(testRun);
            return;
        }
        navigate(`/test-run/${testRun.id}`);
    };

    const baseStatusStyles = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "96px",
        height: "24px",
        padding: "3px 10px",
        borderRadius: "100px",
        textTransform: "capitalize",
        fontSize: "13px",
        fontWeight: 600,
    };

    return (
        <TableRow
            key={testRun.id}
            className="runsAccordionTableBodyRow"
            hover
            onClick={handleShowTestRun}
        >
            <TableCell className="runsAccordionTableBodyCell">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {publicId ? (
                        <span style={{ color: "#6D6E6F", fontWeight: 600 }}>
                            {publicId}
                        </span>
                    ) : null}
                    <span>{testCase?.testCaseName || "-"}</span>
                </Box>
            </TableCell>
            <TableCell className="runsAccordionTableBodyCell">
                {getVersionNumber(
                    testRun.version?.testCaseId,
                    testCase.versions
                )}
            </TableCell>
            <TableCell className="runsAccordionTableBodyCell">
                <Box className="runsAccordionTableBodyStatusContainer">
                    <Box
                        className="runsAccordionTableBodyStatus"
                        sx={{
                            ...baseStatusStyles,
                            ...statusStyles[testRun.status],
                        }}
                    >
                        {testRun.status === "RUNNING"
                            ? "In Progress..."
                            : testRun.status === "COMPLETED"
                            ? "Passed"
                            : testRun.status === "INITIAL_FAILURE"
                            ? "Initial failure"
                            : testRun.status.toLowerCase()}
                    </Box>
                </Box>
            </TableCell>
            <TableCell className="runsAccordionTableBodyCell">
                {testRun.created_by || "-"}
            </TableCell>
            <TableCell className="runsAccordionTableBodyCell">
                {formatDate(testRun?.queued_at)}
            </TableCell>
        </TableRow>
    );
};

export default TestRunsListItem;
